import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-image-popup',
    templateUrl: './image-popup.component.html',
    styleUrls: ['./image-popup.component.scss'],
    standalone: false
})
export class ImagePopupComponent implements OnInit {

	imageUrl: any;
  process = false;

  constructor(
    private dialogRef: MatDialogRef<ImagePopupComponent>,
							@Inject(MAT_DIALOG_DATA) data:any
  ) {
    this.imageUrl = data.imageUrl;
    this.process = true;
  }

  ngOnInit(): void {
  }
}
